/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Source_DetailsInputs */

const cs_templates_source_details = /** @type {(inputs: Templates_Source_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zdroj / Typst`)
};

const en_templates_source_details = /** @type {(inputs: Templates_Source_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source / Typst`)
};

/**
* | output |
* | --- |
* | "Source / Typst" |
*
* @param {Templates_Source_DetailsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_source_details = /** @type {((inputs?: Templates_Source_DetailsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Source_DetailsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_source_details(inputs)
	return cs_templates_source_details(inputs)
});